<script>
	import { goto, preloadData } from '$app/navigation';
	import { browser } from '$app/environment';
	import { getContext } from 'svelte';

	import confetti from 'canvas-confetti';
	import QuoteList from '../../util/quotelist.json';

	if (browser) {
		preloadData('/quote');

		const quotes = getContext('quotes');

		(async () => {
			try {
				const res = await fetch('https://cards-api.frans.app/', { cache: 'no-cache' });
				const json = await res.json();

				quotes.set(json);
			} catch (error) {
				const randomNumber = () => Math.round(Math.random() * (QuoteList.length - 1));
				quotes.set([randomNumber(), randomNumber(), randomNumber(), randomNumber()]);
			}

			setTimeout(() => {
				goto('/quote', { replaceState: true });
				let count = 200;
				let defaults = {
					origin: { y: 0.7 }
				};

				function fire(particleRatio, opts) {
					confetti({
						...defaults,
						...opts,
						disableForReducedMotion: true,
						particleCount: Math.floor(count * particleRatio)
					});
				}

				fire(0.25, {
					spread: 26,
					startVelocity: 55
				});
				fire(0.2, {
					spread: 60
				});
				fire(0.35, {
					spread: 100,
					decay: 0.91,
					scalar: 0.8
				});
				fire(0.1, {
					spread: 120,
					startVelocity: 25,
					decay: 0.92,
					scalar: 1.2
				});
				fire(0.1, {
					spread: 120,
					startVelocity: 45
				});
			}, 1000);
		})();
	}
</script>

<svelte:head>
	<meta name="theme-color" content="#6001e5" />
	<link rel="preload" href="/noise.webp" as="image" />
</svelte:head>

<section>
	<main>
		<svg class="sun-svg" viewBox="0 0 306 306" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M101.6 84.2125L102.984 83.1748L101.761 81.9518L56.8357 37.0268L55.775 35.9662L54.7143 37.0268L37.0393 54.7018L35.9788 55.7624L37.0392 56.823L81.9642 101.761L83.1883 102.985L84.2258 101.599C89.1651 95.0009 95.0138 89.1522 101.6 84.2125ZM165.287 67.9848L167 68.2303V66.5V3V1.5H165.5H140.5H139V3V66.5V68.2303L140.713 67.9848C144.772 67.4032 148.846 67 153 67C157.154 67 161.228 67.4032 165.287 67.9848ZM221.775 101.588L222.813 102.971L224.036 101.748L268.961 56.8105L270.021 55.7499L268.961 54.6893L251.286 37.0143L250.225 35.9535L249.164 37.0145L204.239 81.952L203.017 83.1749L204.4 84.2125C210.986 89.1522 216.835 95.0012 221.775 101.588ZM67.9848 140.713L68.2303 139H66.5H3H1.5V140.5V165.5V167H3H66.5H68.2303L67.9848 165.287C67.4032 161.228 67 157.154 67 153C67 148.846 67.4032 144.772 67.9848 140.713ZM204.413 221.775L203.029 222.813L204.252 224.036L249.177 268.948L250.237 270.008L251.298 268.949L268.985 251.274L270.047 250.213L268.986 249.152L224.061 204.227L222.838 203.004L221.8 204.387C216.848 210.986 210.999 216.835 204.413 221.775ZM84.2122 204.4L83.1744 203.017L81.9518 204.239L37.0393 249.152L35.9787 250.213L37.0393 251.273L54.7143 268.948L55.775 270.009L56.8357 268.948L101.748 224.036L102.971 222.813L101.588 221.775C95.0013 216.835 89.1647 210.999 84.2122 204.4ZM239.5 139H237.77L238.015 140.713C238.597 144.772 239 148.846 239 153C239 157.154 238.597 161.228 238.015 165.287L237.77 167H239.5H303H304.5V165.5V140.5V139H303H239.5ZM140.713 238.015L139 237.77V239.5V303V304.5H140.5H165.5H167V303V239.5V237.77L165.287 238.015C161.228 238.597 157.154 239 153 239C148.846 239 144.772 238.597 140.713 238.015ZM153 217C188.353 217 217 188.353 217 153C217 117.647 188.353 89 153 89C117.647 89 89 117.647 89 153C89 188.353 117.647 217 153 217Z"
				fill="#FFFA19"
				stroke="#5615AC"
				stroke-width="3"
			/>
		</svg>
	</main>
</section>

<style>
	section {
		height: 100%;
		width: 100%;
		position: fixed;
		background: url('/noise.webp') #6a00ff;
		background-size: 72px;
		font: 1em 'Atkinson Hyperlegible';
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	main {
		margin: 0 auto;
		width: 500px;
		max-width: 100%;
	}

	.sun-svg {
		width: 306px;
		height: 306px;
		filter: drop-shadow(0 0 56px rgba(255, 250, 25, 0.62));
	}

	@media (prefers-reduced-motion: no-preference) {
		.sun-svg {
			animation: sun-spin 10s linear both;
		}
	}

	@keyframes sun-spin {
		from {
			transform: rotate(0deg) scale(0.8);
		}

		to {
			transform: rotate(3600deg) scale(1.6);
		}
	}
</style>
